import SubstrateSearchRequest from '../../../data/schema/SubstrateSearchRequest';
import { SearchResultMessage } from '../../../data/schema/SubstrateSearchResponse';
import Message from 'owa-service/lib/contract/Message';
import {
    convertToNormalizedSubject,
    convertToItemId,
    convertUtcDateTimeToRequestTimeZone,
    convertToFlagType,
    convertRecipientToSingleRecipientType,
    convertToFolderId,
    convertSearchSortOrder,
} from './converterHelpers';

export default function convertSearchResultMessageToMessageType(
    searchMessage: SearchResultMessage,
    request: SubstrateSearchRequest
): Message {
    const normalizedSubject = convertToNormalizedSubject(searchMessage.Subject);

    return {
        Categories: searchMessage.Categories,
        ConversationId: convertToItemId(searchMessage.ConversationId),
        ConversationIndex: searchMessage.ConversationIndex,
        ConversationThreadId: {
            Id: searchMessage.ConversationThreadId,
            ChangeKey: null,
        },
        ConversationTopic: normalizedSubject,
        DateTimeReceived: convertUtcDateTimeToRequestTimeZone(
            searchMessage.DateTimeReceived,
            request
        ),
        DateTimeSent: convertUtcDateTimeToRequestTimeZone(searchMessage.DateTimeSent, request),
        LastModifiedTime: convertUtcDateTimeToRequestTimeZone(
            searchMessage.DateTimeLastModified,
            request
        ),
        DisplayBcc: searchMessage.DisplayBcc,
        DisplayCc: searchMessage.DisplayCc,
        DisplayTo: searchMessage.DisplayTo,
        Flag: convertToFlagType(searchMessage.Flag),
        From: convertRecipientToSingleRecipientType(searchMessage.From),
        HasAttachments: searchMessage.HasAttachments,
        Hashtags: searchMessage.Hashtags,
        IconIndex: searchMessage.IconIndex,
        Importance: searchMessage.Importance,
        IsDraft: searchMessage.IsDraft,
        IsRead: searchMessage.IsRead,
        ItemClass: searchMessage.ItemClass || 'IPM.Note',
        ItemId: {
            Id: searchMessage.ItemId.Id,
            ChangeKey: searchMessage.ItemId.ChangeKey,
        },
        MailboxGuids: searchMessage.MailboxGuids,
        ParentFolderId: convertToFolderId(searchMessage.ParentFolderId),
        Preview: searchMessage.Preview,
        Sender: convertRecipientToSingleRecipientType(searchMessage.Sender),
        SenderSMTPAddress: searchMessage.SenderSMTPAddress,
        Sensitivity: searchMessage.Sensitivity,
        SortOrderSource: convertSearchSortOrder(searchMessage.SortOrderSource),
        Subject: searchMessage.Subject,
        ExtendedProperty: [
            {
                // WellKnownProperties.NormalizedSubjectProperty
                ExtendedFieldURI: {
                    DistinguishedPropertySetId: 'Common',
                    PropertyId: 3613,
                    PropertyType: 'String',
                },
                Value: normalizedSubject,
            },
        ],
    };
}
